import PropTypes from "prop-types";
import { useState, useEffect } from "react";

// MUI
import { Button, ClickAwayListener, Grid, IconButton, Typography } from "@mui/material";

// Layouts
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

// Icons
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

export default function AddLocation(props) {
	const {
		data = [],
		showBy = "name",
		selectBy = "locationId",
		orderBy = "",
		disabled = false,
		loading = false,
		error = false,
		noClearIcon = false,
		onChange = () => {},
		onSelect = () => {},
	} = props;

	const [adding, setAdding] = useState(false);
	const [location, setLocation] = useState(null);

	const handleChange = (value) => {
		if (value) {
			setLocation(value);
			onChange?.(value);
		}
	};

	const handleSelectLocation = () => {
		if (props.onSelect) {
			onSelect?.(location);
			setLocation(null);
			setAdding(false);
		}
	};

	const handleClickAway = () => {
		setLocation(null);
		setAdding(false);
	};

	useEffect(() => {
		return () => {
			setLocation(null);
			setAdding(false);
		};
	}, [props]);

	return (
		<ClickAwayListener onClickAway={handleClickAway}>
			{adding ? (
				<Grid container>
					<Grid item xs={true}>
						<SmartSelector
							showBy={showBy}
							selectBy={selectBy}
							orderBy={orderBy}
							options={data}
							selected={location?.[selectBy] ?? null}
							inputProps={{
								placeholder: "Add Location",
							}}
							listBoxProps={{
								sx: { maxHeight: "190px" },
							}}
							popperProps={{
								sx: { minWidth: "240px", maxWidth: "300px" },
							}}
							clearable={!noClearIcon}
							error={error}
							loading={loading}
							onChangeAction={handleChange}
						/>
					</Grid>
					<Grid item xs={1} ml={1}>
						<IconButton size={"small"} onClick={handleSelectLocation}>
							<CheckRoundedIcon fontSize="small" />
						</IconButton>
					</Grid>
				</Grid>
			) : (
				<Button
					fullWidth
					disableRipple
					disableFocusRipple
					disableElevation
					className="!justify-start !capitalize hover:!bg-transparent disabled:opacity-60 disabled:cursor-default"
					disabled={disabled}
					onClick={() => setAdding(true)}
				>
					<Typography className="regular-pt-sans-pro-narrow-label underline !text-primary">Add Location</Typography>
				</Button>
			)}
		</ClickAwayListener>
	);
}
AddLocation.propTypes = {
	data: PropTypes.array,
	showBy: PropTypes.string,
	selectBy: PropTypes.string,
	orderBy: PropTypes.string,
	loading: PropTypes.bool,
	disabled: PropTypes.bool,
	error: PropTypes.bool,
	noClearIcon: PropTypes.bool,
	onChange: PropTypes.func,
	onSelect: PropTypes.func,
};
